Whether the position profile was created by the requesting partner.

If your software cannot ingest objects that are created by another source,
this can be used to filter out such position profiles.
